// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-columns-container {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  height: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.custom-columns-container.mode-edit {
  background: #fafbfc;
  border: 1px solid #e0e7ff;
}

.custom-columns-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f1f5f9;
}
.custom-columns-header .header-content h3 {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px 0;
}
.custom-columns-header .header-content .header-description {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0;
}
.custom-columns-header .header-actions button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 34px;
}
.custom-columns-header .header-actions .edit-btn {
  background: var(--primary-color);
  color: white;
  border: 1px solid rgba(0, 74, 154, 0.2);
}
.custom-columns-header .header-actions .cancel-btn {
  background: #ffffff;
  color: #64748b;
  border: 1px solid #e2e8f0;
}
.custom-columns-header .header-actions .cancel-btn:hover {
  background: #f8fafc;
  color: #1e293b;
}

.fields-list {
  display: flex;
  flex-direction: column;
}

.field-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}
.field-row:last-child {
  border-bottom: none;
}
.field-row:hover {
  background-color: rgba(0, 0, 0, 0.01);
}
@media (max-width: 768px) {
  .field-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}

.field-label {
  flex: 0 0 200px;
  font-weight: 600;
  color: #1e293b;
  font-size: 13.5px;
  padding-right: 12px;
  line-height: 1.3;
}
.field-label .max-length-hint {
  display: block;
  margin-top: 2px;
  font-weight: 400;
  font-size: 11px;
  color: #94a3b8;
}

.field-value {
  flex: 1 1;
  min-width: 0;
}
.field-value .view-value {
  font-size: 14px;
  color: #334155;
  line-height: 1.5;
  word-break: break-word;
  max-width: 85ch;
}
.field-value .view-value .empty-value {
  color: #cbd5e1;
  font-style: italic;
  font-size: 13px;
}
.field-value .edit-input {
  width: 100%;
  max-width: 80ch;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  font-size: 14px;
  line-height: 1.4;
  color: #1e293b;
  background: #ffffff;
  transition: all 0.2s;
}
.field-value .edit-input:focus {
  outline: none;
  border-color: #004a9a;
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);
}
.field-value .edit-input::placeholder {
  color: #cbd5e1;
}

.actions-bar {
  display: flex;
  flex-direction: column-reverse;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}
@media (min-width: 640px) {
  .actions-bar {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.actions-bar .clear-all-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: transparent;
  color: #ef4444;
  border: 1px solid #fecaca;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.actions-bar .clear-all-btn:hover:not(:disabled) {
  background: #fef2f2;
  border-color: #fecaca;
}
.actions-bar .save-cancel-group {
  display: flex;
  gap: 10px;
}
.actions-bar .save-cancel-group .save-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  background: #004a9a;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 74, 154, 0.2);
}
.actions-bar .save-cancel-group .save-btn:hover:not(:disabled) {
  background: #003f84; /* slightly darker than #004a9a */
  transform: translateY(-1px);
}
.actions-bar .save-cancel-group .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/RenderCustomColumns.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,yCAAA;AACJ;AACI;EACI,mBAAA;EACA,yBAAA;AACR;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAAJ;AAGQ;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AADZ;AAIQ;EACI,kBAAA;EACA,cAAA;EACA,SAAA;AAFZ;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AALZ;AAQQ;EACI,gCAAA;EACA,YAAA;EACA,uCAAA;AANZ;AAaQ;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAXZ;AAaY;EACI,mBAAA;EACA,cAAA;AAXhB;;AAiBA;EACI,aAAA;EACA,sBAAA;AAdJ;;AAiBA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,uCAAA;AAdJ;AAgBI;EACI,mBAAA;AAdR;AAiBI;EACI,qCAAA;AAfR;AAkBI;EAfJ;IAgBQ,sBAAA;IACA,uBAAA;IACA,QAAA;EAfN;AACF;;AAkBA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAfJ;AAiBI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAfR;;AAmBA;EACI,SAAA;EACA,YAAA;AAhBJ;AAkBI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAhBR;AAkBQ;EACI,cAAA;EACA,kBAAA;EACA,eAAA;AAhBZ;AAoBI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;AAlBR;AAoBQ;EACI,aAAA;EACA,qBAAA;EACA,2CAAA;AAlBZ;AAqBQ;EACI,cAAA;AAnBZ;;AAwBA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AArBJ;AAuBI;EARJ;IASQ,mBAAA;IACA,8BAAA;IACA,mBAAA;EApBN;AACF;AAsBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AApBR;AAsBQ;EACI,mBAAA;EACA,qBAAA;AApBZ;AAwBI;EACI,aAAA;EACA,SAAA;AAtBR;AAwBQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;AAtBZ;AAyBY;EACI,mBAAA,EAAA,iCAAA;EACA,2BAAA;AAvBhB;AAyBY;EACA,YAAA;EACA,mBAAA;AAvBZ","sourcesContent":[".custom-columns-container {\r\n    padding: 20px;\r\n    background: #ffffff;\r\n    border-radius: 10px;\r\n    height: 100%;\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n\r\n    &.mode-edit {\r\n        background: #fafbfc;\r\n        border: 1px solid #e0e7ff;\r\n    }\r\n}\r\n\r\n.custom-columns-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n    padding-bottom: 12px;\r\n    border-bottom: 2px solid #f1f5f9;\r\n\r\n    .header-content {\r\n        h3 {\r\n            font-size: 1.15rem;\r\n            font-weight: 700;\r\n            color: #1e293b;\r\n            margin: 0 0 4px 0;\r\n        }\r\n\r\n        .header-description {\r\n            font-size: 0.85rem;\r\n            color: #64748b;\r\n            margin: 0;\r\n        }\r\n    }\r\n\r\n    .header-actions {\r\n        button {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 6px;\r\n            padding: 6px 14px;\r\n            border-radius: 5px;\r\n            font-size: 13px;\r\n            font-weight: 600;\r\n            cursor: pointer;\r\n            transition: all 0.2s ease;\r\n            height: 34px;\r\n        }\r\n\r\n        .edit-btn {\r\n            background: var(--primary-color);\r\n            color: white;\r\n            border: 1px solid rgba(0, 74, 154, 0.2);\r\n\r\n            // &:hover {\r\n            //     background:var(--primary-light-color);\r\n            // }\r\n        }\r\n\r\n        .cancel-btn {\r\n            background: #ffffff;\r\n            color: #64748b;\r\n            border: 1px solid #e2e8f0;\r\n\r\n            &:hover {\r\n                background: #f8fafc;\r\n                color: #1e293b;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.fields-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.field-row {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid #f1f5f9;\r\n    transition: background-color 0.15s ease;\r\n\r\n    &:last-child {\r\n        border-bottom: none;\r\n    }\r\n\r\n    &:hover {\r\n        background-color: rgba(0, 0, 0, 0.01);\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 6px;\r\n    }\r\n}\r\n\r\n.field-label {\r\n    flex: 0 0 200px;\r\n    font-weight: 600;\r\n    color: #1e293b;\r\n    font-size: 13.5px;\r\n    padding-right: 12px;\r\n    line-height: 1.3;\r\n\r\n    .max-length-hint {\r\n        display: block;\r\n        margin-top: 2px;\r\n        font-weight: 400;\r\n        font-size: 11px;\r\n        color: #94a3b8;\r\n    }\r\n}\r\n\r\n.field-value {\r\n    flex: 1;\r\n    min-width: 0;\r\n\r\n    .view-value {\r\n        font-size: 14px;\r\n        color: #334155;\r\n        line-height: 1.5;\r\n        word-break: break-word;\r\n        max-width: 85ch;\r\n\r\n        .empty-value {\r\n            color: #cbd5e1;\r\n            font-style: italic;\r\n            font-size: 13px;\r\n        }\r\n    }\r\n\r\n    .edit-input {\r\n        width: 100%;\r\n        max-width: 80ch;\r\n        padding: 8px 10px;\r\n        border: 1px solid #e2e8f0;\r\n        border-radius: 5px;\r\n        font-size: 14px;\r\n        line-height: 1.4;\r\n        color: #1e293b;\r\n        background: #ffffff;\r\n        transition: all 0.2s;\r\n\r\n        &:focus {\r\n            outline: none;\r\n            border-color: #004a9a;\r\n            box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);\r\n        }\r\n\r\n        &::placeholder {\r\n            color: #cbd5e1;\r\n        }\r\n    }\r\n}\r\n\r\n.actions-bar {\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n    gap: 12px;\r\n    margin-top: 24px;\r\n    padding-top: 16px;\r\n    border-top: 1px solid #e2e8f0;\r\n\r\n    @media (min-width: 640px) {\r\n        flex-direction: row;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    .clear-all-btn {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        padding: 8px 14px;\r\n        background: transparent;\r\n        color: #ef4444;\r\n        border: 1px solid #fecaca;\r\n        border-radius: 5px;\r\n        font-size: 13px;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: all 0.2s;\r\n\r\n        &:hover:not(:disabled) {\r\n            background: #fef2f2;\r\n            border-color: #fecaca;\r\n        }\r\n    }\r\n\r\n    .save-cancel-group {\r\n        display: flex;\r\n        gap: 10px;\r\n\r\n        .save-btn {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 6px;\r\n            padding: 8px 20px;\r\n            background: #004a9a;\r\n            color: #ffffff;\r\n            border: none;\r\n            border-radius: 5px;\r\n            font-size: 13px;\r\n            font-weight: 600;\r\n            cursor: pointer;\r\n            box-shadow: 0 1px 2px rgba(0, 74, 154, 0.2);\r\n            //transition: transform 0.1s ease, box-shadow 0.2s ease;\r\n\r\n            &:hover:not(:disabled) {\r\n                background: #003f84; /* slightly darker than #004a9a */\r\n                transform: translateY(-1px);\r\n            }\r\n            &:disabled {\r\n            opacity: 0.6;\r\n            cursor: not-allowed;\r\n        }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
